import { useCallback } from 'react';
import { useTradeCharacterItemMutation } from '@sorrem-client/ui/store';
import { getStoredCanonicalAccountId } from '@sorrem-client/ui/shared/auth-session';
import { useMutationError } from './use-mutation-error';

export interface ItemTradeState {
    isTrading: boolean;
    /** Why the last trade failed, or null. */
    error: string | null;
    /** Trades a carried or stored item for its essence. Resolves to whether it succeeded. */
    trade: (itemId: string) => Promise<boolean>;
}

/** Trading a character's items to a house of exchange for essence, poured into their vessel. */
export function useItemTrade(characterId: string | null): ItemTradeState {
    const accountId = getStoredCanonicalAccountId();
    const [tradeItem, { isLoading: isTrading }] = useTradeCharacterItemMutation();
    const { error, refuse, run } = useMutationError();

    const trade = useCallback((itemId: string): Promise<boolean> => (
        accountId === null || characterId === null
            ? refuse('You need to be signed in to trade.')
            : run(() => tradeItem({ accountId, characterId, itemId }).unwrap(), 'The trade failed. Try again.')
    ), [accountId, characterId, refuse, run, tradeItem]);

    return { isTrading, error, trade };
}
